import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const HeaderRlt1 = () => {
  return <header className="bg-white" data-id="element-18092" data-mp="1kn8yuv5e10li">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-18093" data-mp="1kpv76x03rk4s"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-18094" data-mp="1fuy2g29uvwxp">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-18095" data-mp="1awwizg8ipvlp">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-18096" data-mp="15z4e7lmryf03">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-18097" data-mp="11vg7t69vppgf">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex justify-start mb-3" data-id="element-18098" data-mp="rzv9pj7xl9by">
          <div className="text-xs text-gray-400 font-sans" data-id="element-18099" data-mp="s16arb9zs2zd">Advertorial 1</div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-18100" data-mp="2r9lbmheplvd3">
          <div className="text-left" data-id="element-18101" data-mp="2jv76rq94240t">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-18102" data-mp="2jxtbzj8j47fv">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-18103" data-mp="32okkkikoztt7">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-18104" data-mp="2svlpchuox50m">
        <div className="max-w-4xl mx-auto" data-id="element-18105" data-mp="2xuyhni4bz4al">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-18106" data-mp="2xtncpez5fqhw">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-18107" data-mp="3qcu7xoxk0pmg">
            PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat
            Loss a Scam—Or Are Most Devices Just Built Wrong?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-18108" data-mp="3q9lhb5abg310">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-18109" data-mp="3qbg1ghdrjr41">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-18110" data-mp="3h8x1c51d3slh" />
            </div>
            <div className="flex-1" data-id="element-18111" data-mp="37j3ol0phh7fn">
              <div className="flex items-center" data-id="element-18112" data-mp="37ic1ke9yci0z">
                <div className="font-medium text-gray-900 text-lg" data-id="element-18113" data-mp="37gr9qwf0vd6t">
                  By Dr. Sarah Mitchell, PhD
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-18114" data-mp="2yixdtml66lk6">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-18115" data-mp="2tjcfnedtqh8i" />
                  <span className="text-xs ml-1 font-medium" data-id="element-18116" data-mp="2tknm5lynm33b">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-18117" data-mp="1910kjtf57vdw">
                Exercise Physiology, University of Texas
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-18118" data-mp="1i285l9snezq1">
                <div className="flex items-center mr-4" data-id="element-18119" data-mp="1hzvn8vizancg">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-18120" data-mp="1n009712noaa2" />
                  <span data-id="element-18121" data-mp="qaslpnih7r3i">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-18122" data-mp="qcdgne8pdc1w">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-18123" data-mp="ubw0e6osfh35" />
                  <span data-id="element-18124" data-mp="ucnjii177mcj">47,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-18125" data-mp="z9nrwzlit16t">
            An Independent Analysis by Dr. Sarah Mitchell, PhD | Exercise
            Physiology. Updated: January 2026
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18126" data-mp="bkbko59r7375">
            <div className="mb-1 flex items-center" data-id="element-18127" data-mp="2e8tdd0uezgo5">
              <span className="font-medium mr-2" data-id="element-18128" data-mp="29a06hr9munwy">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18129" data-mp="2n2g58fvi3zs2">
              <span className="font-medium mr-2" data-id="element-18130" data-mp="2iaetqw65qd33">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-18131" data-mp="31zgwki9s5sq0">
        <div className="max-w-4xl mx-auto" data-id="element-18132" data-mp="1bl6o3zzuhjtx">
          <div className="sm:flex items-center" data-id="element-18133" data-mp="1blzx77ma0lf8">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-18134" data-mp="17kmqkvbd0e79">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell in research lab" className="w-full rounded-lg shadow-md" data-id="element-18135" data-mp="17m7mao9eu36p" />
            </div>
            <div className="sm:w-2/3" data-id="element-18136" data-mp="11jm5esqe2ndi">
              <p className="text-sm text-gray-700 mb-2" data-id="element-18137" data-mp="nr69sczthrmm">
                <span className="font-bold" data-id="element-18138" data-mp="nok1uc90la3v">Dr. Sarah Mitchell, PhD</span> has
                spent 25 years in exercise physiology research and clinical
                practice. With a doctorate from the University of Texas, she has
                published extensively on metabolic adaptation and body
                composition.
              </p>
              <p className="text-sm text-gray-700" data-id="element-18139" data-mp="4sk6crgtvofj">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderRlt1;